import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { courses as mockCourses } from '../data/mockData';
import '../styles/Courses.css';

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const location = useLocation();

  useEffect(() => {
    setCourses(mockCourses.filter((course) => course.isPublished));
  }, [location.search]);

  return (
    <div className="apple-page apple-archive">
      <header className="apple-page-hero">
        <p className="apple-eyebrow">Archive</p>
        <h1 className="apple-display">강의 아카이브</h1>
        <p className="apple-lede">
          온라인 강의 판매는 중단되었습니다. 지금은 요강·전형 정보와 루트 파인더를 제공합니다.
        </p>
        <div className="apple-archive-cta">
          <Link to="/guides" className="apple-btn apple-btn-primary">가이드</Link>
          <Link to="/finder" className="apple-link">루트 찾기</Link>
        </div>
      </header>

      <ul className="apple-archive-list">
        {courses.map((course) => (
          <li key={course._id}>
            <Link to={`/courses/${course._id}`}>
              <span className="apple-archive-badge">판매 중단</span>
              <strong>{course.title}</strong>
              <span>{course.category} · {course.level}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Courses;
